import type { FC } from "react";
import { useTranslation } from "next-i18next";
import { Col, Row, Grid, Button } from "antd";
import responsiveColumn from "../../../../methods/responsiveColumn";
import { useRouter } from "next/router";

export const ComplianceSection7: FC = () => {
  const { useBreakpoint } = Grid;
  const screenSize = useBreakpoint();
  const { t } = useTranslation("compliance");

  const router = useRouter();
  return (
    <Row
      style={{
        background: "#254486",
        padding: "80px 0 50px 0",
        color: "#fff",
      }}
      justify={"center"}
      className='stext3'
    >
      <Col
        style={{ textAlign: "center" }}
        {...responsiveColumn([16, 17, 18, 22, 22, 22])}
      >
        <p style={{ fontSize: 20, padding: "0 10px ", lineHeight: 1.5 }}>
          {t("section7_title")}
        </p>
        <p
          style={{
            fontSize: screenSize.xs ? 15 : 16,
            margin: screenSize.xs ? "30px 0" : "30px 4px",
            padding: "0 10px ",
            lineHeight: 1.5,
          }}
        >
          {t("section7_p1")}
        </p>

        <Button
          size='large'
          style={{
            background: "#de9e36",
            border: "#de9e36",
            color: "#fff",
            padding: "10px 60px",
            fontSize: 15,
            marginTop: 5,
            height: "clamp(65px, 4vw, 68px)",
            whiteSpace: "normal",
          }}
          onClick={() => router.push("/about-us/our-unique-practice-model")}
        >
          {t("section7_button")}
        </Button>
      </Col>
    </Row>
  );
};
